import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  CcdlButtonComponent,
  CcdlCheckboxComponent,
  CcdlInputComponent,
  CcdlLinkComponent,
  CcdlSingleSelectComponent,
  ErrorConfig,
  SingleOption,
} from '@cpm-pr1618001/ng-design-lib';
import { Countries, States } from '@cpm-pr1618003/ng-initializer-lib';
import { Subscription } from 'rxjs';

@Component({
  selector: 'sign-up-ui',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CcdlLinkComponent,
    CcdlButtonComponent,
    CcdlCheckboxComponent,
    CcdlInputComponent,
    CcdlSingleSelectComponent,
  ],
  standalone: true,
})
export class SignUpComponent implements OnInit, OnChanges, OnDestroy {
  @Input() signUpForm!: FormGroup;
  @Input() countries!: Countries[];
  @Input() states!: States[];

  @Output() signInViewEmitter: EventEmitter<void> = new EventEmitter<void>();
  @Output() signUpSubmitEmitter: EventEmitter<void> = new EventEmitter<void>();
  @Output() onTermsEmitter = new EventEmitter<void>();
  @Output() onPrivacyEmitter = new EventEmitter<void>();
  @Output() selectedCountry = new EventEmitter<string>();
  @Output() selectedState = new EventEmitter<string>();

  countryOptions: SingleOption[] = [];

  stateOptions: SingleOption[] = [];

  subscription: Subscription = new Subscription();
  isSubmitTriggered: boolean = false;

  firstNameErrorConfig: ErrorConfig = { invalid: 'Please enter valid name.' };
  lastNameErrorConfig: ErrorConfig = { invalid: 'Please enter valid name.' };
  emailErrorConfig: ErrorConfig = { invalid: 'Please enter valid email.' };
  phoneErrorConfig: ErrorConfig = {
    invalid: 'Please enter valid phone number.',
  };
  passwordErrorConfig: ErrorConfig = {
    invalid: 'Please enter valid password.',
  };
  confirmPasswordErrorConfig: ErrorConfig = {
    invalid: 'Please enter valid password.',
  };
  countryErrorConfig: ErrorConfig = { invalid: 'Please select valid countru.' };
  stateErrorConfig: ErrorConfig = { invalid: 'Please select valid state.' };
  zipErrorConfig: ErrorConfig = { invalid: 'Please enter valid zip code.' };
  rememberMeErrorConfig: ErrorConfig = {
    invalid: 'Please select terms and conditions.',
  };

  ngOnInit(): void {
    this.subscription.add(
      this.getControl('country').valueChanges.subscribe(
        (countryCode: string) => {
          this.selectedCountry.emit(countryCode);
          if (this.getControl('state').value) {
            this.getControl('state').setValue('');
          }
        },
      ),
    );

    this.subscription.add(
      this.getControl('state').valueChanges.subscribe((stateCode: string) => {
        this.selectedState.emit(stateCode);
      }),
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.countries?.currentValue) {
      this.formateCountriesOptions();
    }
    if (changes?.states?.currentValue) {
      this.formateStatesOptions();
    }
  }

  formateCountriesOptions(): void {
    this.countryOptions = [];
    if (this.countries?.length > 0) {
      this.countries.forEach((val: Countries) => {
        this.countryOptions.push({
          value: val.countryCode,
          label: val.countryName,
        });
      });
    }
  }

  formateStatesOptions(): void {
    this.stateOptions = [];
    if (this.states?.length > 0) {
      this.states.forEach((val: States) => {
        this.stateOptions.push({
          value: val.stateCode,
          label: val.stateName,
        });
      });
    }
  }

  getControl(controlName: string): FormControl {
    return this.signUpForm.get(controlName) as FormControl;
  }

  onSignInViewClick(): void {
    this.signInViewEmitter.emit();
  }

  signUpClick(): void {
    this.isSubmitTriggered = true;
    this.signUpSubmitEmitter.emit();
  }

  onTermsClick(): void {
    this.onTermsEmitter.emit();
  }

  onPrivacyClick(): void {
    this.onPrivacyEmitter.emit();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
